import React, { type FC } from 'react';
import { ListSortProps } from '../../utility/types';
import SelectListSortDropdown from '../decision-making-page/SelectListSortDropdown';

export type FinalDecisionMakingSubHeaderProps = {
  listSorts: ListSortProps[];
  activeListSort: ListSortProps;
  setActiveListSort: (ListSortProps) => void;
}

const FinalDecisionMakingSubHeader: FC<FinalDecisionMakingSubHeaderProps> = ({
  listSorts,
  activeListSort,
  setActiveListSort,
}) => {
  return (
    <div className="my-4">
      <SelectListSortDropdown
        listSorts={listSorts}
        onListSortSelect={setActiveListSort}
        activeListSort={activeListSort}
      />
    </div>
  );
};

export default FinalDecisionMakingSubHeader;
